var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d2-page-cover"},[_c('p',{staticClass:"d2-page-cover__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"d2-page-cover__sub-title d2-mt-0"},[_vm._v(_vm._s(_vm.subTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }